import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet} from '@angular/router';
import { fader, transite } from './route-animations';
import { AuthService } from './auth/auth.service';
import { Subscription } from 'rxjs/index';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    transite,
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  isAuth = false;
  authSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    angulartics2GoogleTagManager: Angulartics2GoogleTagManager
  ) {
    angulartics2GoogleTagManager.startTracking();
  }

  ngOnInit() {
    this.authSubscription =  this.authService.authChange.subscribe(authStatus => {
      this.isAuth = authStatus;
    });
    this.translate.use('fr');
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];

  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }


}
